<ng-container *ngIf="showValue">
    {{value | currency}}
</ng-container>
<ng-container *ngIf="!showValue">
    <ng-container *ngIf="value">Available</ng-container>
    <ng-container *ngIf="!value">{{0 | currency}}</ng-container>
</ng-container>